import React, { useEffect } from 'react';
import { Form, Input, DatePicker, Alert } from 'antd';
import { SafetyOutlined } from '@ant-design/icons';
import { Trans, useTranslation } from 'react-i18next';
import CBModal from './CBModal';

const { TextArea } = Input;
const PURPLE = '#722ed1';

/**
 * Passage d'un dossier en ARBITRAGE (commission arbitrale).
 * Moins formel qu'un contentieux judiciaire ; pas de niveau de juridiction.
 */
export default function ArbitrageModal({ open, onClose, onConfirm, sinistre, loading }) {
  const { t } = useTranslation('commun');
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) form.resetFields();
  }, [open, form]);

  const handleOk = async () => {
    try {
      const v = await form.validateFields();
      onConfirm({
        dateSaisineArbitrage: v.dateSaisineArbitrage?.format('YYYY-MM-DD') || null,
        observations:         v.observations?.trim() || null,
      });
    } catch { /* validation inline */ }
  };

  return (
    <CBModal
      title={<span><SafetyOutlined style={{ color: PURPLE, marginRight: 8 }} />{t('arbitrageModal.titre')}</span>}
      open={open}
      onCancel={onClose}
      onOk={handleOk}
      okText={t('arbitrageModal.titre')}
      cancelText={t('arbitrageModal.annuler')}
      width={560}
      confirmLoading={loading}
      okButtonProps={{ style: { background: PURPLE, borderColor: PURPLE } }}
      destroyOnClose
    >
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
        message={t('arbitrageModal.alerteTitre')}
        description={
          <Trans
            t={t}
            i18nKey="arbitrageModal.alerteTexte"
            values={{ numero: sinistre?.numeroSinistreLocal || '' }}
            components={{ 1: <strong /> }}
          />
        }
      />

      <Form form={form} layout="vertical" requiredMark={false}>
        <Form.Item name="dateSaisineArbitrage" label={t('arbitrageModal.dateSaisine')}>
          <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" placeholder={t('arbitrageModal.formatDate')} />
        </Form.Item>

        <Form.Item name="observations" label={t('arbitrageModal.observations')}>
          <TextArea
            rows={3}
            placeholder={t('arbitrageModal.observationsExemple')}
            maxLength={1000}
            showCount
          />
        </Form.Item>
      </Form>
    </CBModal>
  );
}
